'use client';

import { c as _c } from "react/compiler-runtime";
import { useFieldArray, useFormContext } from 'react-hook-form';
import { FieldController } from '@module/mdrt-org/shared/components/field-controller/field-controller';
import { SelectField } from '@module/mdrt-org/shared/components/select-field/select-field';
import { MAX_AREA_CODE_LENGTH, MAX_PHONE_NUMBER_LENGTH } from '@module/mdrt-org/shared/utils/constants/inputs-constants';
import { allowOnlyNumbersTransform } from '@module/mdrt-org/shared/utils/helpers/allow-only-numbers';
import { Chip } from '@shared/ui-components/chip/chip';
import { ChipTheme } from '@shared/ui-components/chip/chipTheme';
import { FormInput } from '@shared/ui-components/form-input/form-input';
import { type SelectOption } from '@shared/utils/types/select-option';
import { type ContactInformationFormData } from '../../utils/types/form-data';
import { type AccountSettingsContactInformationContent } from './get-account-settings-contact-information-content';
import { usePhoneSectionData } from './use-phone-section-data';
import styles from './phone-section.module.scss';
const PARENT_CLASSNAME = 'phone-section';
export const PhoneSection = t0 => {
  const $ = _c(16);
  const {
    cmsContent
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      name: "phoneNumbers"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    append,
    fields,
    remove
  } = useFieldArray(t1);
  const {
    watch
  } = useFormContext();
  const {
    defaultPhoneNumber,
    phoneIsoCodeOptions,
    phoneTypeOptions
  } = usePhoneSectionData();
  let t2;
  if ($[1] !== cmsContent || $[2] !== fields || $[3] !== phoneIsoCodeOptions || $[4] !== phoneTypeOptions || $[5] !== remove || $[6] !== watch) {
    const watchedPhoneNumbers = watch("phoneNumbers");
    const filterUnselectedPhoneTypeOptions = item => !watchedPhoneNumbers.some(fieldItem => item?.value === fieldItem.phoneTypeOption?.value);
    t2 = fields.map((field, index) => <div key={field.id}><div className={styles[`${PARENT_CLASSNAME}__header`]}><h2 className={styles[`${PARENT_CLASSNAME}__header-title`]}>{index === 0 ? cmsContent.primaryPhoneTitle : cmsContent.additionalPhoneTitle}</h2>{index > 0 && <button className={styles[`${PARENT_CLASSNAME}__remove-button`]} onClick={() => remove(index)} type="button">{cmsContent.removeLabel}</button>}</div><div className={styles[`${PARENT_CLASSNAME}__phone-type-input-container`]}><SelectField label={cmsContent.phoneTypeLabel} name={`phoneNumbers.${index}.phoneTypeOption`} options={phoneTypeOptions.filter(filterUnselectedPhoneTypeOptions)} rules={{
          required: cmsContent.requiredLabel
        }} /></div><div className={styles[`${PARENT_CLASSNAME}`]}><div className={styles[`${PARENT_CLASSNAME}__input-container`]}><SelectField isSearchable={true} label={cmsContent.ISOCodeLabel} name={`phoneNumbers.${index}.phoneIsoCodeOption`} options={phoneIsoCodeOptions} rules={{
            required: cmsContent.requiredLabel
          }} /></div><div className={styles[`${PARENT_CLASSNAME}__input-container`]}><FieldController label={cmsContent.areaCodeLabel} name={`phoneNumbers.${index}.phoneAreaCode`} transform={allowOnlyNumbersTransform}><FormInput maxLength={MAX_AREA_CODE_LENGTH} /></FieldController></div><div className={styles[`${PARENT_CLASSNAME}__input-container`]}><FieldController label={cmsContent.phoneNumberLabel} name={`phoneNumbers.${index}.phoneNumber`} rules={{
            required: cmsContent.requiredLabel
          }}><FormInput maxLength={MAX_PHONE_NUMBER_LENGTH} /></FieldController></div></div></div>);
    $[1] = cmsContent;
    $[2] = fields;
    $[3] = phoneIsoCodeOptions;
    $[4] = phoneTypeOptions;
    $[5] = remove;
    $[6] = watch;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== append || $[9] !== cmsContent || $[10] !== defaultPhoneNumber || $[11] !== fields.length) {
    t3 = fields.length < 3 && <Chip isSmall={true} label={`+ ${cmsContent.additionalPhoneLabel}`} onClick={() => append({
      ...defaultPhoneNumber,
      phoneTypeOption: null
    })} theme={ChipTheme.Light} />;
    $[8] = append;
    $[9] = cmsContent;
    $[10] = defaultPhoneNumber;
    $[11] = fields.length;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t2 || $[14] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};